export default "<p>moisturealert works!</p>\n"